import CustomModal from 'components/global/CustomModal'
import React from 'react'
import { creationEventStore } from 'state/event/eventCreationStore'
import { eventTypesList } from './constants'
import { EventTypeListing } from 'types/event/events'
import { infoMessage } from 'api/global'
import { useHistory } from 'react-router-dom'
import { leagueEventStore } from 'state/league/leagueEvent'
import { communityStore } from 'state/event/community'
import { externalStore } from 'state/event/external'
import { classesEventStore } from 'state/classes/classesStore'

type EventType = 'event' | 'community' | 'external' | 'fundraiser' | 'league' | 'classes'

const EventTypeModal: React.FC = () => {
  const history = useHistory()
  const {
    eventTypeModalVisible,
    setEventTypeModalVisible,
    setEventData,
    setStepCounter,
  } = creationEventStore(store => ({
    eventTypeModalVisible: store.eventTypeModalVisible,
    setEventTypeModalVisible: store.setEventTypeModalVisible,
    setEventData: store.setEventData,
    setStepCounter: store.setStepCounter,
  }))
  const { setLeagueData, setLeagueCounter } = leagueEventStore(store => ({
    setLeagueData: store.setLeagueData,
    setLeagueCounter: store.setLeagueStepCounter,
  }))
  const { setCommunityData, setCommunityStep } = communityStore(store => ({
    setCommunityStep: store.setCommunityStepCounter,
    setCommunityData: store.setCommunityData,
  }))
  const { setExternalData, setExternalStepCounter } = externalStore(store => ({
    setExternalData: store.setExternalData,
    setExternalStepCounter: store.setExternalStepCounter,
  }))
  const { setClassesData, setClassesStepCounter } = classesEventStore(store => ({
    setClassesData: store.setClassesData,
    setClassesStepCounter: store.setStepCounter,
  }))

  const hanldeTypeClick = (type: EventType) => () => {
    switch (type) {
      case 'event':
        setEventTypeModalVisible(false)
        setEventData(null)
        setStepCounter(0)
        history.push('/spaces/create-event')
        break
      case 'community':
        setEventTypeModalVisible(false)
        setCommunityData(null)
        setCommunityStep(0)
        history.push('/create-community')
        break
      case 'external':
        setExternalData(null)
        setExternalStepCounter(0)
        setEventTypeModalVisible(false)
        history.push('/create-external')
        break
      case 'fundraiser':
        infoMessage('It will be coming soon')
        break
      case 'league':
        setLeagueData(null)
        setLeagueCounter(0)
        setEventTypeModalVisible(false)
        history.push('/spaces/create-league')
        break
      case 'classes':
        setClassesData(null)
        setClassesStepCounter(0)
        setEventTypeModalVisible(false)
        history.push('/spaces/create-classes')
        break
      default:
        infoMessage('Event type is not in the listing')
    }
  }

  return (
    <>
      <CustomModal
        openModal={eventTypeModalVisible}
        closeModal={setEventTypeModalVisible}
        title={'What would you like to create?'}
        footer={false}
      >
        <div className="flex flex-wrap gap-20px justify-center">
          {eventTypesList.map((type: EventTypeListing) => {
            return (
              <div
                key={type.id}
                className="flex align-center justify-center flex-col border-1px radius-12 px-20px py-20px gap-20px pointer"
                style={{ width: '150px' }}
                onClick={hanldeTypeClick(type.title.toLowerCase() as EventType)}
              >
                <img src={type.icon} alt={type.title} />
                <h3 className="text-16 w-600">{type.title}</h3>
              </div>
            )
          })}
        </div>
      </CustomModal>
    </>
  )
}

export default EventTypeModal
